import { services } from '../../../../../constants/services';
import { getAll } from '../../../../../utils/api';
import { GetRelatedDataFormPermissionsDto } from '../../../dtos/rol.dto';

export const GetRelatedDataFormPermissionsService = async (roleId: number) => {
    const response = await getAll<GetRelatedDataFormPermissionsDto>(`${services.users}/access/roles/related-data-form-permissions?roleId=${roleId}`);
    return response;
}